// ATENÇÃO: Sempre que um novo campo for adicionado
// set a propriedade visible para false
export default [
  {
    id: 'departmentIni',
    text: 'Dpto. Inicial',
    title: 'Depatamento que iniciou a call',
    visible: true
  },
  {
    id: 'departmentFrom',
    text: 'Dpto. De',
    title: 'Nome do departamento do usuário / device de onde a call veio',
    visible: true
  },
  {
    id: 'departmentTo',
    text: 'Dpto. Para',
    title: 'Nome do departameto do usuario / device atual da call',
    visible: true
  },
  {
    id: 'input',
    text: 'Número de Entrada',
    title: 'Número para o qual o cliente ligou',
    visible: true
  },
  {
    id: 'client',
    text: 'Cliente',
    title: 'Nome do cliente que está na ligação',
    visible: true
  },
  {
    id: 'clientNo',
    text: 'Num. Cliente',
    title: 'Número do telefone do cliente que está na ligação',
    visible: true
  },
  {
    id: 'from',
    text: 'Número De',
    title: 'Quem encaminhou a chamada para o ramal atual',
    visible: true
  },
  {
    id: 'userFrom',
    text: 'De',
    title: 'Usuário ou grupo que encaminhou a chamada',
    visible: true
  },
  {
    id: 'userName',
    text: 'Usuário / Atendedor',
    title: 'Nome do usuário ou grupo que está atendendo a camada',
    visible: true
  },
  {
    id: 'extension',
    text: 'Ramal',
    title: 'Ramal atual da chamada',
    visible: true
  },
  {
    id: 'way',
    text: 'Sentido',
    title: 'Origem da chamada',
    visible: true
  },
  {
    id: 'start',
    text: 'Início',
    title: 'Tempo de chamada desde o começo',
    visible: true
  },
  {
    id: 'channelIn',
    text: 'Canal Entrada',
    title: 'Porta da operadora (linha) em que a chamada entrou',
    visible: true
  },
  {
    id: 'channelOut',
    text: 'Canal Saída',
    title: 'Porta da operadora (linha) em que a chamada saiu',
    visible: true
  },
  {
    id: 'status',
    text: 'Estatus',
    title: 'Status da chamada no momento (ring, fila, atendendo ...)',
    visible: true
  },
  {
    id: 'statusTime',
    text: 'T. Estatus',
    title: 'Tempo em que a chamda está no status',
    visible: true
  },
  {
    id: 'score',
    text: 'Nota Total',
    title: 'Nota do dada pelo cliente para este atendimento!',
    visible: true
  }
];
